import { render } from "./Parents.vue?vue&type=template&id=0e7ec07c"
import script from "./Parents.vue?vue&type=script&lang=js"
export * from "./Parents.vue?vue&type=script&lang=js"

import exportComponent from "/Users/arkane/Dev/Projects/Web/ecole-alpha.proj/ecole-alpha.2024-2025.web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.34_vue@3.3.8_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__